import styled from 'styled-components';
import { useEffect } from 'react';

// Components
import FinanceItem from '../../molecules/academic/FinanceItem';
import SimpleLoading from '../../../common/SimpleLoading';
import ErrorResponse from '../../../common/ErrorResponse';
import CommonButton from '../../../common/CommonButton';
import FinanceHeader from './FinanceHeader';

// Material UI
import { Button } from '@mui/material';

// Redux
import { financesActions } from '../../../../redux/actions';
import { useDispatch, useSelector } from 'react-redux';

const Finance = () => {
    // REDUX
    const dispatch = useDispatch();
    const { finances, errorList } = useSelector((state) => state.finances);

    // EFFECTS
    useEffect(() => {
        if (finances === null) {
            dispatch(financesActions.getFinancesRequest());
        }
    }, []);

    const restartPay = () => {
        dispatch(financesActions.getFinancesRequest());
    };

    const handleGoToFinance = () => {
        window.open(
            'https://api.whatsapp.com/send?phone=5492617504810&text=Hola%2C quisiera contactarme con Finanzas',
            '_blank'
        );
        return;
    };

    // RETURN
    if (finances === null && errorList === null) {
        return <SimpleLoading padding="4rem" />;
    }

    if (finances === null || finances?.error) {
        return (
            <ErrorResponse
                message={'No se pudieron cargar los psagos'}
                button={
                    <Button
                        onClick={restartPay}
                        color="primary"
                        variant="contained"
                    >
                        Reintentar
                    </Button>
                }
            />
        );
    }

    const hasPrograms = finances?.account_data?.programs?.length > 0;

    return (
        <>
            <FinanceContainer>
                <FinanceHeader
                    current_balance_usd={
                        finances?.account_data?.current_balance_usd
                    }
                    total_investment_usd={
                        finances?.account_data?.total_investment_usd
                    }
                />
                {hasPrograms &&
                    finances?.account_data?.programs.map((finance, index) => (
                        <FinanceItem finance={finance} key={index} />
                    ))}
            </FinanceContainer>
            <MoreInfo>
                <p>
                    Si tienes alguna adicional, te invitamos a ponerte en
                    contacto con el Área de Finanzas.
                </p>
                <CommonButton
                    label="Contactar con Finanzas"
                    variant="outlined"
                    onClick={handleGoToFinance}
                    FontAwesomeIconName="fa-light fa-headset"
                />
            </MoreInfo>
        </>
    );
};

export default Finance;

const FinanceContainer = styled.div`
    width: 100%;
    padding: 2rem;
    background-color: #fff;
    border-radius: 20px;
    display: flex;
    flex-direction: column;
    gap: 2rem;
`;

const MoreInfo = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: start;
    align-items: start;
    gap: 1rem;
    margin-top: 1rem;

    p {
        font-size: 15px;
        font-weight: 600;
        color: #b31d15;
    }
`;
